import { sortBy } from "lodash";

import { ComplianceProgramActionBasicItemProps } from "../helpers";

export function sortByCompletedItemsLast<
  T extends ComplianceProgramActionBasicItemProps,
>(items: T[]): T[] {
  return sortBy(items, (item) => {
    return item.statusCompleted ? 1 : 0;
  });
}
